import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className="modern-footer">
      <Container>
        {isMobile ? (
          <>
            <div className="footer-logo centered-logo">
              <img src="/images/footer/logo.png" alt="Logo Cooptaleo" />
            </div>
            <Box mt={2} textAlign="center" fontSize="14px" opacity={0.7}>
              © {currentYear} COOPTALEO. Tous droits réservés.
            </Box>
          </>
        ) : (
          <>
            <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start">
              <Grid item xs={12} md={3} className="footer-logo-block">
                <div className="footer-logo centered-logo">
                  <img src="/images/footer/logo.png" alt="Logo Cooptaleo" />
                </div>
                <Typography variant="body2" className="footer-address centered-address">
                  231 rue Saint-Honoré<br />
                  75001 – PARIS<br />
                  France
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <Typography variant="subtitle1" className="footer-title">Informations utiles</Typography>
                <Link href="/confidentiality" className="footer-link">Politique de confidentialité (RGPD)</Link><br />
                <Link href="/cookie-policy" className="footer-link">Politique de cookies</Link><br />
                <Link href="/legale" className="footer-link">Mentions légales</Link><br />
                <Link href="/cgu" className="footer-link">CGU </Link>/ <Link href="/cgv" className="footer-link">CGV</Link>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <Typography variant="subtitle1" className="footer-title">Ressources</Typography>
                <Link href="/fiches" className="footer-link">Fiches métiers</Link><br />
                <Link href="/faq" className="footer-link">FAQ</Link>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography variant="subtitle1" className="footer-title">Rejoignez le réseau</Typography>
                <Box className="footer-socials">
                  <IconButton
                    className="linkedin-link"
                    href="https://www.linkedin.com/company/cooptaleo"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/footer/linkedin.png" alt="LinkedIn" className="social-icon-img" />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>

            <Box mt={5} textAlign="center" fontSize="14px" opacity={0.7}>
              © {currentYear} COOPTALEO. Tous droits réservés.
            </Box>
          </>
        )}
      </Container>
    </Box>
  );
};

export default Footer;
